export * from './file-uploads.service'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/file-uploads/index.ts